import React from "react";
import { Dropdown, Icon } from "semantic-ui-react";

export interface GatewayActionItem {
    key: string;
    text: string;
    icon?: string;
    disabled?: boolean;
    onClick: () => void | Promise<void>;
}

interface GatewayActionsProps {
    actions: GatewayActionItem[];
}

const GatewayActions: React.FC<GatewayActionsProps> = ({ actions }) => (
    <Dropdown
        icon={null}
        floating
        pointing={false} // Remove the arrow
        direction="left" // Optional: menu opens to the left
        trigger={<Icon name="ellipsis vertical" link />}
    >
        <Dropdown.Menu>
            {actions.map((action) => (
                <Dropdown.Item
                    key={action.key}
                    icon={action.icon}
                    text={action.text}
                    disabled={action.disabled}
                    onClick={action.onClick}
                />
            ))}
        </Dropdown.Menu>
    </Dropdown>
);

export default GatewayActions;
